import { FC, SVGProps } from 'react';

export const TicketCalendarIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
		<path
			d="M3.10559 7.88428H16.1875"
			stroke="currentColor"
			strokeWidth="1.09821"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M12.5864 2.49902V4.8926"
			stroke="currentColor"
			strokeWidth="1.09821"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M6.70984 2.49902V4.8926"
			stroke="currentColor"
			strokeWidth="1.09821"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M16.1906 9.47213V7.0275C16.197 4.84069 14.8697 3.65039 12.7275 3.65039H6.56924C4.43269 3.65039 3.09888 4.84069 3.09888 7.0275V13.6098C3.09888 15.8307 4.43269 17.0485 6.56924 17.0485H8.36117"
			stroke="currentColor"
			strokeWidth="1.09821"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M16.902 14.28C16.902 16.0574 15.4612 17.4983 13.683 17.4983C11.9057 17.4983 10.4648 16.0574 10.4648 14.28C10.4648 12.5027 11.9057 11.061 13.683 11.061C15.4612 11.061 16.902 12.5027 16.902 14.28Z"
			stroke="currentColor"
			strokeWidth="1.09821"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M14.683 15.119L13.6654 14.511V13.2031"
			stroke="currentColor"
			strokeWidth="1.09821"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
